<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  ~ Copyright (c) 2019. BMW Group. All rights reserved.
  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->

<app-generic-modal [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   [primaryActionEnabled]="isValid"
                   (primaryActionEvent)="save()"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">

        <app-input-text #biCategoryName
                        (inputValueChange)="onInputValueChange($event, this.nameMessages, nameInput, updateStoreStateName)"
                        [messages]="nameMessages"
                        [validators]="validators.name"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-bi-category-modal-name"
                        label="BI category name"
                        maxLength="15"
                        placeholder="Please, write a BI category name"></app-input-text>
        <app-input-text #biCategoryCode
                        (inputValueChange)="onInputValueChange($event, this.codeMessages, codeInput, updateStoreStateCode,
                        true,'BI category')"
                        [messages]="codeMessages"
                        [validators]="validators.code"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-bi-category-modal-code"
                        label="BI category code"
                        maxLength="4"
                        placeholder="Please, write a BI category code, e.g. *"></app-input-text>
        <app-input-text #biCategoryRange
                        (inputValueChange)="onInputValueChange($event, this.rangeMessages, this.rangeInput, updateStoreStateRange)"
                        [messages]="rangeMessages"
                        [validators]="validators.range"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-bi-category-modal-range"
                        label="BI category range"
                        maxLength="15"
                        placeholder="Please, write a range e.g. >= 6"></app-input-text>
        <app-active-input (checkState)="setActiveInputState($event)" [entityName]="ENTITY_NAME"
                          [state]="$safeNavigationMigration(state?.isActive)"></app-active-input>

    </div>

</app-generic-modal>
